<template>
  <Form ref="loginForm" :model="form" :rules="rules" style="display: flex">
    <div style="margin-right: 50px">
      <Row class="top-info" type="flex" align="middle">
        <!-- <Col span="10" class="logo-wrap">
          <img src="@/assets/images/logo.jpg" />
        </Col> -->
        <Col span="24">
          <div class="title">欢迎登录</div>
        </Col>
      </Row>
      <!-- <Row class="tab-wraps" type="flex" align="middle" :gutter="16">
        <Col span="12" @click.native="switchTab(0)">
          <div class="tab" :class="{ actived: tabIndex === 0 }">企业登录</div>
        </Col>
        <Col span="12" @click.native="switchTab(1)">
          <div class="tab" :class="{ actived: tabIndex === 1 }">工会登录</div>
        </Col>
      </Row> -->
      <template v-if="tabIndex === 0">
        <FormItem prop="userName" class="input-wrap">
          <Input v-model="form.phone" placeholder="请输入手机号">
            <span slot="prepend">
              <Icon :size="16" type="bianzu2"></Icon>
            </span>
          </Input>
        </FormItem>
        <FormItem prop="password" v-if="!passLogin">
          <Row class="input-wrap">
            <Col span="15">
              <Input type="text" v-model="form.code" placeholder="请输入验证码">
                <span slot="prepend">
                  <Icon :size="14" type="bianzu"></Icon>
                </span>
              </Input>
            </Col>
            <Col span="9" class="code-wrap">
              <div @click="showTokenModal" v-if="remain <= 0">
                <div class="codebtn" type="button">获取验证码</div>
              </div>
              <div v-else>
                <div class="codebtn" disabled>{{ remain }}s后重新发送</div>
              </div>
            </Col>
          </Row>
        </FormItem>
        <FormItem v-if="passLogin" class="input-wrap">
          <Input v-model="form.code" type="password" placeholder="请输入密码">
            <span slot="prepend">
              <Icon :size="16" type="bianzu"></Icon>
            </span>
          </Input>
        </FormItem>
      </template>
      <template v-else>
        <FormItem prop="userName" class="input-wrap">
          <Input v-model="form.phone" placeholder="请输入账号">
            <span slot="prepend">
              <Icon :size="16" type="bianzu2"></Icon>
              账号
            </span>
          </Input>
        </FormItem>
        <FormItem prop="password" class="input-wrap">
          <Input type="password" v-model="form.code" placeholder="请输入密码">
            <span slot="prepend">
              <Icon :size="14" type="bianzu"></Icon>
              密码
            </span>
          </Input>
        </FormItem>
      </template>
      <FormItem>
        <Button @click="doLogin" type="primary" long style="font-size: 18px">登录</Button>
      </FormItem>
      <div v-if="tabIndex === 0" class="rule-text">
        <Checkbox v-model="checked"></Checkbox>
        我已阅读并同意
        <router-link class="rule-url" to="rule">《就业云用户协议与隐私声明》</router-link>
      </div>
      <div v-if="tabIndex === 0" class="rule-text">
        <div class="fx-row">
          <!-- <a class="fx-1" @click="showPass(true)" v-if="!passLogin">账户密码登录</a> -->
          <a class="fx-1" @click="showPass(false)" v-if="passLogin">短信验证码登录</a>
          <!-- <a class="fx-1" @click="toResetPass">忘记密码</a> -->
          <!-- <a class="fx-1" @click="toRegister">新用户注册</a> -->
        </div>
      </div>
    </div>
    <div class="code">
      <div class="title">职工之家APP扫码登录</div>
      <canvas
        id="canvas"
        class="img"
        height="200"
        width="200"
        :style="{ opacity: disabled ? '0.1' : '1', cursor: 'pointer' }"
        @click="disabled && getQRcode()"
      ></canvas>
    </div>

    <Modal v-model="tokenModal" width="300px" title="输入图形验证码" @on-ok="handleGetCode">
      <div style="text-align: center">
        <img :src="imgUrl" alt="" style="width: 236px; height: 72px" @click="getImageToken" />
        <Input style="margin-top: 10px" v-model="smsForm.code" placeholder="请输入图形验证码"></Input>
      </div>
    </Modal>
    <Modal v-model="showAddCompanyDrawer" :width="600" :footer-hide="true" title="企业基本信息">
      <company-form :token="accessToken" v-if="accessToken" @finish="showAddCompanyDrawer = false"></company-form>
    </Modal>
  </Form>
</template>
<script>
import { mapActions } from 'vuex';
import companyForm from './company-form.vue';
import { v4 as uuidv4 } from 'uuid';
import QRCode from 'qrcode';
import config from '@/config/index';

export default {
  name: 'LoginForm',
  props: {
    userNameRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: '账号不能为空', trigger: 'blur' }];
      }
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: '密码不能为空', trigger: 'blur' }];
      }
    }
  },
  components: {
    companyForm
  },
  data() {
    return {
      showAddCompanyDrawer: false,
      tokenModal: false,
      tabIndex: 0,
      imgUrl: '',
      form: {
        phone: '',
        code: ''
      },
      smsForm: {
        uuid: '',
        phone: '',
        code: ''
      },
      accessToken: '',
      checked: false,
      remain: 0,
      passLogin: false,
      showPassLogin: process.env.NODE_ENV === 'development',
      uuid: '',
      timer: null,
      delay: 3000,
      num: 1,
      disabled: false,
      limitTime: 180
    };
  },
  computed: {
    rules() {
      return {
        phone: this.userNameRules,
        code: this.passwordRules
      };
    }
  },
  mounted() {
    this.getQRcode();
  },
  beforeRouteLeave() {
    clearInterval(this.timer);
  },
  methods: {
    ...mapActions(['getUserInfo']),
    switchTab(index) {
      this.tabIndex = index;
      this.form.phone = '';
      this.form.code = '';
    },
    gotoRules() {
      this.$router.push({
        name: 'rule'
      });
    },
    showPass(show) {
      this.form.code = '';
      this.passLogin = show;
    },
    toResetPass() {
      this.$router.push({
        name: 'resetPass'
      });
    },
    toRegister() {
      this.$router.push({
        name: 'register'
      });
    },
    showTokenModal() {
      this.smsForm.code = '';
      var valid = this.valide(this.form.phone);
      if (!valid) {
        this.$Message.error({
          content: '请输入正确的手机号'
        });
        return false;
      }
      this.tokenModal = true;
      this.getImageToken();
    },
    getImageToken() {
      this.$axios
        .request({
          url: 'front/v1/user/captcha'
        })
        .then(res => {
          this.smsForm.uuid = res.id;
          this.imgUrl = res.data;
        });
    },
    handleGetCode() {
      var that = this;
      var valid = this.valide(this.form.phone);
      if (!valid) {
        this.$Message.error({
          content: '请输入正确的手机号'
        });
        return false;
      } else if (valid === 'phone') {
        that.remain = 60;

        this.smsForm.phone = this.form.phone;
        this.$axios
          .request({
            url: 'front/v1/user/sendToken',
            method: 'post',
            data: this.smsForm
          })
          .then(res => {
            var interval = setInterval(function () {
              if (that.remain > 0) {
                that.remain--;
              } else {
                clearInterval(interval);
                interval = null;
              }
            }, 1000);
            this.$Message.success({
              content: '验证码发送成功'
            });
          })
          .catch(res => {
            this.remain = 0;
          });
      }
    },
    valide(phoneOrEmail) {
      if (!phoneOrEmail) {
        return false;
      }
      var emailReg = new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/);
      var phoneReg = new RegExp(/^1\d{10}$/);
      if (phoneReg.test(phoneOrEmail)) {
        return 'phone';
      }

      return false;
    },
    doLogin(e) {
      if (this.tabIndex === 0 && !this.checked) {
        this.$Message.error({
          content: '请先阅读并同意《就业云隐私声明》'
        });
        return;
      }
      if (this.tabIndex === 1 && this.form.phone.trim() === '') {
        this.$Message.error({
          content: '账号不能为空'
        });
        return;
      }
      if (this.tabIndex === 1 && this.form.code.trim() === '') {
        this.$Message.error({
          content: '密码不能为空'
        });
        return;
      }
      var valid = this.valide(this.form.phone);
      var data = {
        phone: this.form.phone,
        token: this.form.phone,
        code: this.form.code,
        type: this.passLogin ? 'phone_password' : valid
      };
      this.handleSubmit(data);
    },
    handleSubmit(data) {
      // this.$emit('on-success-valid', {
      //   identity: this.tabIndex === 0 ? 'qiye' : 'gonghui',
      //   phone: data.phone,
      //   code: data.code,
      //   type: data.type
      // });
      this.$axios
        .request({
          // url: 'front/v1/common/mockLogin?username=' + this.form.phone + '&scope=company',
          url: 'front/v1/common/companyLogin',
          method: 'post',
          data: this.form
        })
        .then(res => {
          if (res.code === 200) {
            this.$store.commit('setToken', res.data);
            this.getUserInfo().then(res => {
              this.$router.push({
                name: 'zhiweiIndex'
              });
            });
          } else if (res.code === 501) {
            this.$Modal.confirm({
              title: '提示',
              content: res.msg,
              onOk: () => {
                this.showAddCompanyDrawer = true;
                this.accessToken = res.data;
              }
            });
          }
        });
    },
    getUnion() {
      this.$axios.request({ url: 'api/union/index' }).then(res => {
        if (res.success) {
          let union = res.data;
          if (union && union.union_member.role_msg === '主管理员') {
            localStorage.setItem('superGonghui', 1);
          }
        }
      });
    },
    getQRcode() {
      this.uuid = uuidv4();
      QRCode.toCanvas(
        document.getElementById('canvas'),
        `${this.showPassLogin ? config.baseUrl.dev : config.baseUrl.pro}h5/#/pages/job-seekers/index?uuid=${this.uuid}`,
        { width: 200, errorCorrectionLevel: 'H' },
        function (error) {
          if (error) console.error(error);
          console.log('success!');
        }
      );
      this.disabled = false;
      this.num = 1;
      this.loginCode();
    },
    loginCode() {
      this.timer = setInterval(() => {
        if (this.num < this.limitTime) {
          this.disabled = false;
          this.num++;
        } else {
          // 超时，重新刷新二维码
          clearInterval(this.timer);
          this.getQRcode();
          // this.disabled = true;
        }
        this.$axios
          .request({
            url: `/front/v1/common/scanLogin?uuid=company-${this.uuid}`
          })
          .then(res => {
            if (res.code === 200) {
              clearInterval(this.timer);
              this.$store.commit('setToken', res.data);
              this.getUserInfo().then(res => {
                this.$router.push({
                  name: 'zhiweiIndex'
                });
              });
            } else if (res.code === 501) {
              clearInterval(this.timer);
              this.$Modal.confirm({
                title: '提示',
                content: res.msg,
                onOk: () => {
                  this.showAddCompanyDrawer = true;
                  this.accessToken = res.data;
                }
              });
            }
          })
          .catch(res => {
            console.log('error', res);
            this.disabled = true;
            clearInterval(this.timer);
          });
      }, this.delay);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="less" scoped>
/deep/ .ivu-form-item {
}
/deep/ .ivu-input-group {
  top: 0;
}
/deep/ .ivu-input {
  height: 30px;
  box-sizing: border-box;
}
.fx-row {
  text-align: center;
}
.fx-1 {
  padding: 0 15px;
  display: inline-block;
  border-right: 1px solid #d6000f;
  color: #d6000f;
  line-height: 1;
}
.fx-row .fx-1:last-child {
  border-right: none;
}

/deep/ .ivu-input {
  // font-size: 16px;
}
</style>
